<template>
  <nav class="bg-opacity-75 rounded flex items-center justify-between flex-wrap bg-black p-6">
    <div class="flex items-center flex-shrink-0 text-white mr-6">
      <!-- <svg
        class="fill-current h-8 w-8 mr-2"
        width="54"
        height="54"
        viewBox="0 0 54 54"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"
        />
      </svg> -->
      <!-- <span class="ml-8 font-semibold text-3xl tracking-tight">{{name}}</span> -->
      <router-link to="/" class="ml-8 font-semibold text-3xl tracking-tight"><slot></slot></router-link>
    </div>
    <div class="lg:hidden xl:hidden">
      <button
        @click="menuToggle"
        class="flex items-center px-3 py-2 rounded text-gray-300 hover:text-orange-500"
      >
        <!-- Icon when menu is closed. -->
        <!-- Menu open: "hidden", Menu closed: "block" -->
        <svg
          v-bind:class="{block: !isOpen, hidden: isOpen}"
          class="h-6 w-6"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        <!-- Icon when menu is open. -->
        <!-- Menu open: "block", Menu closed: "hidden" -->
        <svg
          v-bind:class="{block: isOpen, hidden: !isOpen }"
          class="h-6 w-6"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
    <div
      v-bind:class="{block: isOpen, hidden: !isOpen}"
      class="w-full flex-grow lg:flex lg:w-auto justify-end"
    >
      <!-- <router-link @click.native="menuToggle" to="/about" class="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-white font-bold hover:text-white mr-4">about</router-link>
      <router-link @click.native="menuToggle" to="/services" class="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-white font-bold hover:text-white mr-4">services</router-link>
      <router-link @click.native="menuToggle" to="/projects" class="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-white font-bold hover:text-white mr-4">projects</router-link>
      <router-link @click.native="menuToggle" to="/contact" class="cursor-pointer block mt-4 lg:inline-block lg:mt-0 text-white font-bold hover:text-white mr-4">contact</router-link>-->

      <router-link
        v-for="item in menu"
        :key="item.name"
        @click.native="menuToggle"
        :to="item.ref"
        class="cursor-pointer block mt-4 mr-8 lg:inline-block lg:mt-0 text-xl font-bold text-gray-200 hover:text-orange-500 hover:underline"
      >{{item.name}}</router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  props: ["menu", "name"],
  data() {
    return {
      isOpen: false,
      // menu: [
      //   {
      //     ref: "/about",
      //     name: "about"
      //   },
      //   {
      //     ref: "/services",
      //     name: "services"
      //   },
      //   {
      //     ref: "/projects",
      //     name: "projects"
      //   },
      //   {
      //     ref: "/contact",
      //     name: "contact"
      //   }
      // ]
    };
  },
  methods: {
    menuToggle() {
      if (this.isOpen) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
    }
  }
};
</script>
